import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import InstructionList from './Instruction/List';
import InstructionCreate from './Instruction/Create';
import InstructionDetail from './Instruction/Detail';

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    InspectionTime: { visible: false, label: '', required: false },
    InspectionDetails: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false }
}

const defaultReplyFields = {
    ReplyStatus: { visible: false, label: '', required: false },
    ReplyComment: { visible: false, label: '', required: false },
    ReplyAction: { visible: false, label: '', required: false }
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };

    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;

    fields.Type.clauses = clauses;

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.InspectionTime =  { visible: true, label: resources.InstructionTypeLabel, required: true };
    fields.InspectionTime.clauses = clauses;
    fields.InspectionDetails = { visible: true, label: resources.InstructionClauseLabel, required: true };

    return fields;
}

///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid) => {
    const replyFields = { ...defaultReplyFields };

    var replyOptions = [
        { value: 'Defect Found', display: languageFile["OPTIONS.STATUS.Defect Found"] },
        { value: 'No Defect Found', display: languageFile["OPTIONS.STATUS.No Defect Found"] }
    ];

    replyFields.ReplyStatus = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.STATUS"], required: true };
    replyFields.ReplyStatus.replyOptions = replyOptions;
    replyFields.ReplyComment = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMMENTS"], required: true };
    replyFields.ReplyAction = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.ACTIONS"], required: true };
    
    return replyFields;
}

class InstructionsRouter extends React.Component {
    constructor(props) {
        super(props);

        this.notifyingParty = props.workflowItem.notifyingParty;
        this.replyingParty = props.workflowItem.replyingParty;



        this.notificationType = '43.1SUP';
        this.documentType = 'Document431sup';
        this.replyPeriod = props.workflowItem.replyPeriod;
        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;

        return (
            <Routes caseSensitive>
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<InstructionList
                        {...this.props}
                        
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        notificationType={this.notificationType}
                    />}

                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <InstructionCreate
                                {...this.props}
                                title={this.notificationName}
                                notificationType={this.notificationType}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    exact
                    element={<InstructionDetail
                        {...this.props}
                        replyPeriod={this.replyPeriod}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        
                        documentType={this.documentType}
                        notificationType={this.notificationType}
                        notifyUserFilter={workflowItem.notifyUserFilter}
                    />}
                />
            </Routes>
        );
    }
};




export default (InstructionsRouter);